import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

const DRAW_BASE_URL = `${environment.apiUrl2}/portal-draw`;
const APP_BASE_URL = `${environment.apiUrl2}/applications`;

@Injectable({
  providedIn: 'root',
})
export class PortalDrawService {
  private http: HttpClient = inject(HttpClient);

  getAllDraws(): Observable<{ data: any[] }> {
    return this.http.get<{ data: any[] }>(`${DRAW_BASE_URL}`);
  }

  getActivatedDraws(): Observable<any[]> {
    return this.http.get<any[]>(`${DRAW_BASE_URL}/activated`);
  }

  initializeDraw(draw: { examId: string; quantityOfApplications: number }): Observable<any> {
    return this.http.post<any>(`${APP_BASE_URL}/initialize-portal-draw`, draw);
  }

  initializeManualDraw(draw: { examId: string; applicationIds: string[] }): Observable<any> {
    return this.http.post<any>(`${APP_BASE_URL}/initialize-manual-portal-draw`, draw);
  }

  updateDraw(draw: { id: string; examId: string; quantityOfApplications: number }): Observable<any> {
    return this.http.put<any>(DRAW_BASE_URL, draw);
  }

  getSingleDrawByExamId(examId: string): Observable<any> {
    return this.http.get<any>(`${DRAW_BASE_URL}/exam/${examId}`);
  }

  getSingleDrawById(drawId: string): Observable<any> {
    return this.http.get<any>(`${DRAW_BASE_URL}/single/${drawId}`);
  }

  deleteDrawById(drawId: string): Observable<any> {
    return this.http.delete<any>(`${DRAW_BASE_URL}/single/${drawId}`);
  }

  /** Draws kept as history after every application left them (resubmission).
   *  Tirages archivés — toutes leurs candidatures les ont quittés. */
  getArchivedDraws(): Observable<any[]> {
    return this.http.get<any[]>(`${DRAW_BASE_URL}/archived`);
  }

  /** Restore an archived draw to the active listings.
   *  Réactive un tirage archivé. */
  unarchiveDrawById(drawId: string): Observable<any> {
    return this.http.post<any>(`${DRAW_BASE_URL}/${drawId}/unarchive`, {});
  }

  /**
   * Submitted applications belonging to no draw — the pool a new draw is built
   * from, ordered first-come-first-served (oldest submission first).
   *
   * Candidatures soumises sans tirage — le bassin d'un nouveau tirage, trié
   * premier arrivé, premier servi.
   */
  getUndrawnApplications(query: { examId: string; page?: number; limit?: number; search?: string; previouslyDrawn?: boolean }): Observable<{ data: any[]; total: number; page: number; limit: number }> {
    let params = new HttpParams().set('examId', query.examId);
    if (query.page) params = params.set('page', String(query.page));
    if (query.limit) params = params.set('limit', String(query.limit));
    if (query.search) params = params.set('search', query.search);
    if (query.previouslyDrawn) params = params.set('previouslyDrawn', 'true');
    return this.http.get<{ data: any[]; total: number; page: number; limit: number }>(`${APP_BASE_URL}/undrawn`, { params });
  }
}
